var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M4 25h3.077v-3H4v3zm6.154 0h3.077v-3h-3.077v3zm6.154 0h3.077v-3h-3.077v3zm6.154 0h3.076v-3h-3.076v3zm6.153 0h3.077v-3h-3.077v3zm6.154 0h3.077v-3H34.77v3zm6.154 0H44v-3h-3.077v3z", fill: "currentColor", fillRule: "nonzero", stroke: "none", strokeWidth: 1 })));
});
